export enum CUSTOMER_DOCUMENT_STATUS {
  NOT_GENERATED = 'not_generated',
  GENERATED = 'generated',
  SENT = 'sent',
}
